import { Checkbox } from "@/components/ui/checkbox";

export const CourseMultiSelect = ({ courses, selected, onChange }) => {
  const toggle = (id) =>
    onChange(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);
  return (
    <div className="mt-2 border border-border rounded-sm max-h-56 overflow-y-auto divide-y divide-border" data-testid="invite-course-list">
      {courses.length === 0 && <div className="p-3 text-xs text-muted-foreground">No courses yet.</div>}
      {courses.map((c) => (
        <label key={c.id} className="flex items-center gap-3 p-3 cursor-pointer hover:bg-secondary/60 transition-colors">
          <Checkbox
            checked={selected.includes(c.id)}
            onCheckedChange={() => toggle(c.id)}
            data-testid={`invite-course-checkbox-${c.id}`}
          />
          <span className="text-sm">{c.title}</span>
        </label>
      ))}
    </div>
  );
};
